module.exports = __webpack_public_path__ + "static/media/pipego.44560030.png";